import { render, staticRenderFns } from "./AnnouncementManage.vue?vue&type=template&id=2c8cc395&scoped=true"
import script from "./AnnouncementManage.vue?vue&type=script&lang=js"
export * from "./AnnouncementManage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementManage.vue?vue&type=style&index=0&id=2c8cc395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8cc395",
  null
  
)

export default component.exports